import {
  HierarchyDto,
  PipelineLicenseStageDto,
  PipelineLicenseStakeholderDto,
  PLStageActivityDto,
  PLStakeholderMatrixDto,
  PLStakeholderMatrixRaciDto,
  PLActivityActionPersonDto,
  PipelineLicenseCategoryDto,
  IdentityUserDto,
  PipelineTemplateDto,
  PlrstageactivityDto,
} from '@cradua/data';
import { BehaviorSubject, Observable } from 'rxjs';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'cradua-pl-stage-activity-container',
  templateUrl: './pl-stage-activity-container.component.html',
  styleUrls: ['./pl-stage-activity-container.component.css'],
})
export class PlStageActivityContainerComponent implements OnInit {
  plstageactivities$: Observable<PLStageActivityDto[]>;
  plstakeholdersmatrix$: Observable<PLStakeholderMatrixDto[]>;
  plstakeholdersmatrixraci$: Observable<PLStakeholderMatrixRaciDto[]>;
  plrstageactivies$: Observable<PlrstageactivityDto[]>;
  hierarchys$: Observable<HierarchyDto[]>;
  pipelinelicensestakeholders$: Observable<PipelineLicenseStakeholderDto[]>;
  pipelinelicensestages$: Observable<PipelineLicenseStageDto[]>;
  actionpersons$: Observable<PLActivityActionPersonDto[]>;
  stagecategories$: Observable<PipelineLicenseCategoryDto[]>;
  identityusers$: Observable<IdentityUserDto[]>;
  isLoading$: Observable<any>;
  categoryloading$: Observable<any>;
  isLoadingActionPerson$: Observable<any>;
  isLoadingIdentityuser$: Observable<any>;
  isloadingTemplate$: Observable<any>;

  isLoadingRaci$: Observable<any>;
  isLoadingStage$: Observable<any>;
  isLoadingHolder$: Observable<any>;
  isLoadingMatrix$: Observable<any>;
  isLoadingMatrixRaci$: Observable<any>;
  templates$: Observable<PipelineTemplateDto[]>;
  isVeiwTemplate = false;
  selectedData;
  constructor(
    private gatewayFacade: GatewayFacade,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.categoryloading$ = this.gatewayFacade.isLoadingGateway(
      'PipelineLicenseCategory'
    );
    this.stagecategories$ = this.gatewayFacade.loadGateway(
      'PipelineLicenseCategory'
    );
    this.isLoadingActionPerson$ = this.gatewayFacade.isLoadingGateway(
      'PLActivityActionPerson'
    );
    this.actionpersons$ = this.gatewayFacade.loadGateway(
      'PLActivityActionPerson'
    );
    this.isLoadingRaci$ = this.gatewayFacade.isLoadingGateway('Hierarchy');
    this.hierarchys$ = this.gatewayFacade.loadGateway('Hierarchy');
    this.isLoadingStage$ = this.gatewayFacade.isLoadingGateway(
      'PipelineLicenseStage'
    );
    this.pipelinelicensestages$ = this.gatewayFacade.loadGateway(
      'PipelineLicenseStage'
    );

    this.isLoadingHolder$ = this.gatewayFacade.isLoadingGateway(
      'PipelineLicenseStakeholder'
    );
    this.pipelinelicensestakeholders$ = this.gatewayFacade.loadGateway(
      'PipelineLicenseStakeholder'
    );

    this.isLoading$ = this.gatewayFacade.isLoadingGateway('PLStageActivity');
    this.plstageactivities$ = this.gatewayFacade.loadGateway('PLStageActivity');

    this.isLoadingMatrix$ = this.gatewayFacade.isLoadingGateway(
      'PLStakeholderMatrix'
    );
    this.plstakeholdersmatrix$ = this.gatewayFacade.loadGateway(
      'PLStakeholderMatrix'
    );

    this.isLoadingMatrixRaci$ = this.gatewayFacade.isLoadingGateway(
      'PLStakeholderMatrixRaci'
    );
    this.plstakeholdersmatrixraci$ = this.gatewayFacade.loadGateway(
      'PLStakeholderMatrixRaci'
    );

    this.plrstageactivies$ = this.gatewayFacade.loadGateway('PLRStageActivity');

    this.isLoadingIdentityuser$ = this.gatewayFacade.isLoadingGateway(
      'IdentityUser'
    );
    this.identityusers$ = this.gatewayFacade.loadGateway('IdentityUser');
    this.isloadingTemplate$ = this.gatewayFacade.isLoadingGateway(
      'PipelineTemplate'
    );
    this.templates$ = this.gatewayFacade.loadGateway('PipelineTemplate');
  }

  onSubmitStage(pullData) {
    // declare two empty array to hold update and create data
    const allUpdates = [];
    const addAllPLStages = [];

    // loop through the form data to check for update and create
    for (let i = 0; i < pullData.length; i++) {
      if (pullData[i].Activities) {
        this.onSubmitPlStageActivity(pullData[i].Activities);
      }

      // delete pullData[i].Activities;
      if (pullData[i].newStage) {
        addAllPLStages.push(pullData[i]);
      } else {
        allUpdates.push(pullData[i]);
      }
    }

    // console.log('activity', activities);

    // check if the addAllPLStageActivity array is not empty, then dispatch the data to the store
    if (addAllPLStages.length > 0) {
      this.gatewayFacade.add('PipelineLicenseStage', addAllPLStages);
      // this.store.dispatch(PLStageActivityStoreActions.addPLStageActivity({newPLStageActivity: addAllPLStageActivity}));
    }

    if (allUpdates.length > 0) {
      // dispatch update data to the store
      this.gatewayFacade.update('PipelineLicenseStage', allUpdates, ['id']);
    }
  }

  viewTemplate(data) {
    this.isVeiwTemplate = data.isview;
    if (data.isview) {
      this.selectedData = data;
    }
  }

  onSubmitPlStageActivity(pullData) {
    // console.log('activity data', pullData);

    // declare two empty array to hold update and create data
    const allUpdates = [];
    const addAllPLStageActivity = [];

    // loop through the form data to check for update and create
    for (let i = 0; i < pullData.length; i++) {
      this.onSubmitPLActivityAction(pullData[i].Actionpersons);
      this.onSubmitPLStakeholderMatrix(pullData[i].Stakeholdermatrix);
      // delete pullData[i].Stakeholdermatrix;
      // delete pullData[i].Actionpersons;
      if (pullData[i].isNew) {
        addAllPLStageActivity.push(pullData[i]);
      } else {
        allUpdates.push(pullData[i]);
      }
    }

    // check if the addAllPLStageActivity array is not empty, then dispatch the data to the store
    if (addAllPLStageActivity.length > 0) {
      this.gatewayFacade.add('PLStageActivity', addAllPLStageActivity);
      // this.store.dispatch(PLStageActivityStoreActions.addPLStageActivity({newPLStageActivity: addAllPLStageActivity}));
    }

    if (allUpdates.length > 0) {
      // dispatch update data to the store
      this.gatewayFacade.update('PLStageActivity', allUpdates, ['id']);
    }
  }

  onSubmitPLActivityAction(pullData) {
    //const newPullData = formValue.PLStageActivityes;

    // declare two empty array to hold update and create data
    const allUpdates = [];
    const addAllPLActions = [];

    // loop through the form data to check for update and create
    for (let i = 0; i < pullData.length; i++) {
      if (pullData[i].isNew) {
        addAllPLActions.push(pullData[i]);
      } else {
        allUpdates.push(pullData[i]);
      }
    }

    // check if the addAllPLStakeholderMatrix array is not empty, then dispatch the data to the store
    if (addAllPLActions.length > 0) {
      this.gatewayFacade.add('PLActivityActionPerson', addAllPLActions);
    }

    // dispatch update data to the store
    if (allUpdates.length > 0) {
      this.gatewayFacade.update('PLActivityActionPerson', allUpdates, ['id']);
    }
  }

  onDeleteActivity(ids) {
    if (ids) {
      this.gatewayFacade.remove('PLStageActivity', [ids]);
    }
  }

  onDeleteStage(ids) {
    if (ids) {
      this.gatewayFacade.remove('PipelineLicenseStage', [ids]);
    }
  }

  onSubmitPLStakeholderMatrix(pullData) {
    //const newPullData = formValue.PLStageActivityes;

    // declare two empty array to hold update and create data
    const allUpdates = [];
    const addAllPLStakeholderMatrix = [];

    // loop through the form data to check for update and create
    for (let i = 0; i < pullData.length; i++) {
      this.onSubmitPLStakeholderMatrixRaci(pullData[i].Racies);
      // delete pullData[i].Racies;
      if (pullData[i].isNew) {
        addAllPLStakeholderMatrix.push(pullData[i]);
      } else {
        allUpdates.push(pullData[i]);
      }
    }

    // check if the addAllPLStakeholderMatrix array is not empty, then dispatch the data to the store
    if (addAllPLStakeholderMatrix.length > 0) {
      this.gatewayFacade.add('PLStakeholderMatrix', addAllPLStakeholderMatrix);
    }

    // dispatch update data to the store
    if (allUpdates.length > 0) {
      this.gatewayFacade.update('PLStakeholderMatrix', allUpdates, ['id']);
    }
  }

  onDeleteMatrix(ids) {
    if (ids) {
      this.gatewayFacade.remove('PLStakeholderMatrix', [ids]);
    }
  }

  onSubmitPLStakeholderMatrixRaci(data) {
    const pullData = data;
    //const newPullData = formValue.addAllPLStakeholderMatrixRaci;

    // declare two empty array to hold update and create data
    const allUpdates = [];
    const addAllPLStakeholderMatrixRaci = [];

    // loop through the form data to check for update and create
    for (let i = 0; i < pullData.length; i++) {
      if (pullData[i].isNew) {
        addAllPLStakeholderMatrixRaci.push(pullData[i]);
      } else {
        allUpdates.push(pullData[i]);
      }
    }

    // check if the addAllPLStakeholderMatrixRaci array is not empty, then dispatch the data to the store
    if (addAllPLStakeholderMatrixRaci.length > 0) {
      this.gatewayFacade.add(
        'PLStakeholderMatrixRaci',
        addAllPLStakeholderMatrixRaci
      );
    }

    if (allUpdates.length > 0) {
      // dispatch update data to the store
      this.gatewayFacade.update('PLStakeholderMatrixRaci', allUpdates, ['id']);
    }
  }

  onDeleteMatrixRaci(ids) {
    if (ids) {
      this.gatewayFacade.remove('PLStakeholderMatrixRaci', [ids]);
    }
  }

  onDeleteTemplate(id) {
    this.gatewayFacade.remove('PipelineTemplate', [id]);
  }

  onSubmitTemplate(pullData) {
    if (pullData.id) {
      this.gatewayFacade.update('PipelineTemplate', [pullData], ['id']);
    } else {
      delete pullData.id;
      this.gatewayFacade.add('PipelineTemplate', [pullData]);
    }
  }

  onDeletePlrStage(ids: PlrstageactivityDto[]) {
    if (ids) {
      for (let stage of ids) {
        this.gatewayFacade.remove('PLRStageActivity', [stage.id]);
      }
    }
  }
}
